import { openRamsRecordModal } from '../../../State/ramsRecordModal'

export default () => async (dispatch) => {

  dispatch(openRamsRecordModal())

}